import { html } from 'lit-html';
import { ItemRequestJsEnv } from '../models/item_request_js_env';

export const SendFailed = (model: ItemRequestJsEnv) => {
  if (model.isSendFailed) {
    return html`
    <div span style="color:#ff0000; font-size:20px;">システムエラーが発生しました。</div>`;
  } else {
    return html``;
  }
}

